import { render, staticRenderFns } from "./coach.vue?vue&type=template&id=3c3122b3&scoped=true"
import script from "./coach.vue?vue&type=script&lang=js"
export * from "./coach.vue?vue&type=script&lang=js"
import style0 from "./coach.vue?vue&type=style&index=0&id=3c3122b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3122b3",
  null
  
)

export default component.exports